<template>
  <layout-general v-if="modalVisible === 'export-table'" @close="modalClose()">
    <h4 class="modal-title" slot="header">{{ $t('general.actions.export') }} {{ $t('modal.export_table.answer_table') }}</h4>
    <div slot="body">
      <div>
        <h4 class="help-block">{{ $t('modal.export_table.insert') }}:</h4>
        <input type="text" v-model="email"/>
      </div>
    </div>

    <div slot="footer">
      <button class="btn btn-default" @click="modalClose()">{{ $t('general.actions.cancel') }}</button>
      <button @click="reportExport(email)" class="btn">
        {{ $t('general.actions.export') }} {{ $t('general.labels.table') }}
      </button>
    </div>
  </layout-general>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LayoutGeneral from './layout/General.vue';

export default {
  data() {
    return {
      email: '',
    };
  },
  components: {
    LayoutGeneral,
  },
  computed: mapGetters({
    modalVisible: 'modalVisible',
  }),
  methods: mapActions([
    'reportExport',
    'modalClose',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** ExportTable.vue?2e7ee3f0
 **/